<template>
  <div>
    <h2 class="mb-6">Remove Comas from String</h2>

    <!-- Input Field with Action Row -->
    <div class="field-container mb-4">
      <div class="actions-row">
        <v-btn icon text class="elevation-0" @click="pasteText">
          <v-icon>mdi-content-paste</v-icon>
        </v-btn>
      </div>
      <v-textarea
        v-model="inputString"
        label="Paste your string with commas here"
        outlined
      ></v-textarea>
    </div>

    <!-- Convert Button -->
    <v-btn color="primary" @click="removeComas" class="mb-6">Convert</v-btn>

    <!-- Output Field with Action Row -->
    <div class="field-container">
      <div class="actions-row">
        <v-btn icon text class="elevation-0" @click="copyText">
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </div>
      <v-textarea
        v-model="outputString"
        label="Output (Commas Removed)"
        readonly
        outlined
      ></v-textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "RemoveComas",
  data() {
    return {
      inputString: "",
      outputString: "",
    };
  },
  methods: {
    removeComas() {
      this.outputString = this.inputString.replace(/,/g, "");
    },
    async pasteText() {
      try {
        const text = await navigator.clipboard.readText();
        this.inputString = text;
      } catch (err) {
        this.handleClipboardError("read from the clipboard");
      }
    },
    async copyText() {
      try {
        await navigator.clipboard.writeText(this.outputString);
      } catch (err) {
        this.handleClipboardError("copy text to the clipboard");
      }
    },
    handleClipboardError(action) {
      alert(
        `Unable to ${action}. Please make sure your browser has clipboard access.`
      );
    },
  },
};
</script>

<style>
.field-container {
  margin-bottom: 20px;
}

.actions-row {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
</style>
